import type from './type.js';
export default (function (args) {
  var keyOrder = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  // if called with more than 3 arguments, we return the arguments
  if (args.length >= 3) return Array.prototype.slice.call(args);
  // with less than 3 args we check if first arg is object
  // and use the keyOrder string to extract and sort properties
  if (type(args[0]) == 'object' && keyOrder) {
    return keyOrder.split('').filter(function (k) {
      return args[0][k] !== undefined;
    }).map(function (k) {
      return args[0][k];
    });
  }
  // otherwise we just return the first argument
  // (which we suppose is an array of args)
  return args[0].slice(0);
});